@if (!forcePolaris) {
  <div [attr.data-e2e]="e2e" [attr.data-info-level]="infoLevel">
    <div class="feedback row">
      <!-- feedback icon -->
      <div class="col-12 col-md-4 col-xl-3">
        <div class="alert mx-n1 mx-md-0" [ngClass]="iconClass.background">
          <span class="alert-icon" [ngClass]="iconClass.icon" aria-hidden="true"></span>
        </div>
      </div>
      <!-- feedback body -->
      <div class="col-12 col-md-8 col-xl-9">
        <!-- default or custom title -->
        @if (title) {
          <h2 class="h3 feedback-title h3" [attr.data-e2e]="e2e + '-title'">{{ title }}</h2>
        } @else {
          <div [attr.data-e2e]="e2e + '-title'">
            <ng-container *ngTemplateOutlet="customTitle"></ng-container>
          </div>
        }
        <!-- default or custom text -->
        @if (displayedText && displayedText.length > 0) {
          <div [attr.data-e2e]="e2e + '-body'">
            @for (val of displayedText; track val; let index = $index) {
              <p class="feedback-text">{{ val }}</p>
            }
          </div>
        } @else {
          <div [attr.data-e2e]="e2e + '-body'">
            <p class="feedback-text">
              <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
            </p>
          </div>
        }
        <!-- confirmation button -->
        @if (confirmationLabel) {
          <div class="feedback-button">
            <a
              [href]="hrefUrl"
              class="btn btn-secondary"
              (click)="feedbackConfirm(); (false)"
              [attr.data-e2e]="e2e + '-confirmation'"
            >
              {{ confirmationLabel }}</a
            >
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div
    class="ecm-frame ecm-panel bg-white d-flex flex-column flex-md-row"
    [attr.data-e2e]="e2e"
    [attr.data-info-level]="infoLevel"
  >
    <!-- icon -->
    <span
      class="mr-md-3 material-feedback-icon"
      [ngClass]="iconClass.icon + ' ' + iconClass.iconColor"
      aria-hidden="true"
    ></span>
    <!-- content -->
    <div class="pt-2 material-feedback-content-overflow">
      <!-- title -->
      @if (title) {
        <!-- mobile render -->
        <h1 class="d-block d-md-none h2 text-center" [attr.data-e2e]="e2e + '-title'">{{ title }}</h1>
        <!-- desktop render, child of <h1> page -->
        <h2 class="d-none d-md-block h3" [attr.data-e2e]="e2e + '-title'">{{ title }}</h2>
      }
      <!-- custom html title -->
      @if (!title) {
        <div [attr.data-e2e]="e2e + '-title'">
          <ng-container *ngTemplateOutlet="customTitle"></ng-container>
        </div>
      }
      <!-- body -->
      <div class="mt-3" [attr.data-e2e]="e2e + '-body'" [ngClass]="{ 'mb-3': confirmationStyle }">
        <div [attr.data-e2e]="e2e + '-body'">
          <p class="feedback-text">
            <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
          </p>
        </div>
      </div>
      @if (confirmationStyle) {
        <!-- link / button -->
        <div>
          @switch (confirmationStyle) {
            <!-- link -->
            @case ('link') {
              <!-- mobile separator -->
              <hr class="d-block d-md-none" />
              <a
                class="o-link-arrow"
                [href]="hrefUrl"
                (click)="feedbackConfirm(); (false)"
                [attr.data-e2e]="e2e + '-confirmation'"
              >
                {{ confirmationLabel }}
              </a>
            }
            <!-- button primary -->
            @case ('button-primary') {
              <button
                class="btn btn-primary"
                (click)="feedbackConfirm(); (false)"
                [attr.data-e2e]="e2e + '-confirmation'"
              >
                {{ confirmationLabel }}
              </button>
            }
            <!-- button secondary -->
            @case ('button-secondary') {
              <button
                class="btn btn-secondary"
                (click)="feedbackConfirm(); (false)"
                [attr.data-e2e]="e2e + '-confirmation'"
              >
                {{ confirmationLabel }}
              </button>
            }
          }
        </div>
      }
    </div>
  </div>
}

<ng-template #customTitle>
  <ng-content select="[title]"></ng-content>
</ng-template>

<!-- ✅ Template pour capturer le contenu projeté - TOUJOURS présent dans le DOM -->
<!-- Suite au passage au control flow syntax et l'incompatibilité @else avec ng-content -->
<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>
